class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;

        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        document.dispatchEvent(new CustomEvent('ajaxLoadMore:init'))
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    document.dispatchEvent(new CustomEvent('ajaxLoadMore:init'))
  }

  static renderProductGridContainer(html) {
    const filterColors = document.querySelector("[js-filter-colors]");
    const colorFacets = filterColors?.querySelectorAll("input:checked");

    const ajaxProductContainer = new DOMParser()
    .parseFromString(html, 'text/html')
    .getElementById('ProductGridContainer');

    const productContainer = document.getElementById('ProductGridContainer');

    if(colorFacets?.length) {
      ajaxProductContainer.querySelectorAll("[js-product-card-list-item]").forEach( productItem => {
        let isVisible = false;
        colorFacets.forEach( input => {
          const color = input.getAttribute("data-color");
          const colorSwatch = productItem.querySelector(`[js-data-variant-image][data-color="${color}"]`);
          if(colorSwatch) isVisible = true;
        })
  
        if(!isVisible) {
          productItem.remove();
        }
      })
    }

    productContainer.innerHTML = ajaxProductContainer.innerHTML;
    productContainer.classList.remove("fade-main-product-grid");

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });


      /* Card_product_media_gallery_slider */
      new Swiper('.Card_product_media_gallery_slider', {
        loop: true,
        grabCursor: true,
        spaceBetween: 0,
        slidesPerGroup: 1,
        slidesPerView: 1,
        watchSlidesProgress: true,
        draggable:!0,
        autoHeight:!1,
        watchOverflow:!0,
        threshold:10,
        mousewheel:{
          forceToAxis:!0
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }
      })

    
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('collection-counter-wrapper');
    // container.innerHTML = count;
    let total_products = document.querySelectorAll('#custom-collection-product-Loop [js-product-card-list-item]').length;

    if(total_products === 1){
        total_products = `(${total_products}) item`
    } else {
        total_products = `(${total_products}) items`
    }

    if(count) {
      count.querySelector('[js-pdp-filter-product-count]').textContent = total_products
    }

    container?.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.textContent = total_products;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile')?.closest('menu-drawer')?.bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('custom-collection-product-Loop').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
   
    // if (event.srcElement.className == 'mobile-facets__checkbox') {
    //   const searchParams = this.createSearchParams(event.target.closest('form'));
    //   this.onSubmitForm(searchParams, event);
    //  } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';
      sortFilterForms.forEach((form) => {
       // if (!isMobile) {
         // if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
         // }
      //  } else if (form.id === 'FacetFiltersFormMobile') {
       //   forms.push(this.createSearchParams(form));
       // }
      });
      this.onSubmitForm(forms.join('&'), event);
    //}
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.minInput = this.querySelector('#minRange');
    this.maxInput = this.querySelector('#maxRange');
    this.textInputs = this.querySelectorAll('.field__input');

    this.minValue = parseInt(this.minInput.min, 10);
    this.maxValue = parseInt(this.maxInput.max, 10);

    this.minInput.addEventListener('input', this.updateMinInput.bind(this));
    this.maxInput.addEventListener('input', this.updateMaxInput.bind(this));
    this.textInputs.forEach(input => input.addEventListener('change', this.updateFromTextInput.bind(this)));
  }

  updateMinInput(event) {
    let minValue = parseInt(this.minInput.value, 10);
    let maxValue = parseInt(this.maxInput.value, 10);

    if (minValue + 8 > maxValue) {
      minValue = maxValue - 8;
      this.minInput.value = minValue;
    }
    this.textInputs[0].value = minValue;
    const minInputValueElement = document.querySelector('.min-input-value');
    minInputValueElement.textContent = minValue;
  }

  updateMaxInput(event) {
    let maxValue = parseInt(this.maxInput.value, 10);
    let minValue = parseInt(this.minInput.value, 10);

    if (maxValue - 8 < minValue) {
      maxValue = minValue + 8;
      this.maxInput.value = maxValue;
    }
    this.textInputs[1].value = maxValue;
    const maxInputValueElement = document.querySelector('.max-input-value');
    maxInputValueElement.textContent = maxValue;
  }

  updateFromTextInput(event) {
    let minValue = parseInt(this.textInputs[0].value, 10);
    let maxValue = parseInt(this.textInputs[1].value, 10);

    if (minValue + 8 > maxValue) {
      minValue = maxValue - 8;
      this.textInputs[0].value = minValue;
    }
    if (maxValue - 8 < minValue) {
      maxValue = minValue + 8;
      this.textInputs[1].value = maxValue;
    }

    this.minInput.value = minValue;
    this.maxInput.value = maxValue;
  }

  setMinAndMaxValues() {
    const min = parseInt(this.minInput.min, 10);
    const max = parseInt(this.maxInput.max, 10);

    this.textInputs[0].setAttribute('data-min', min);
    this.textInputs[1].setAttribute('data-max', max);
  }
}

customElements.define('price-range', PriceRange);


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
    document.dispatchEvent(new CustomEvent('ajaxLoadMore:init'))
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);


document.addEventListener('DOMContentLoaded', () => {
    let total_products = document.querySelectorAll('[js-product-card-list-item]').length;
    if (total_products === 1) {
        total_products = `(${total_products}) item`;
    } else {
        total_products = `(${total_products}) items`;
    }
    if(document.querySelector('#collection-counter-wrapper')) {
      document.querySelector('#collection-counter-wrapper').innerHTML = total_products;
    }
});
